// extracted by mini-css-extract-plugin
export default {"question":"Question_question__5nqux","line":"Question_line__MBbgP"};